import React from 'react';
import { Card, makeStyles, useTheme } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import styles from './styles';

export interface AutoCardProps {
  children?: React.ReactNode;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  overrideClasses?: any;
  id?: string;
  noCircles?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const AutoCard: React.FC<AutoCardProps> = ({
  children,
  role,
  companySelected,
  overrideClasses,
  id,
  noCircles,
  onClick,
}) => {
  const theme = useTheme();

  const useStyles = makeStyles(styles(theme, overrideClasses, onClick));

  const classes = useStyles({});

  return (
    <Card
      id={id}
      onClick={onClick}
      className={clsx(classes.container, {
        [classes.greenCircles]: role === RolesEnum.admin && !companySelected,
        [classes.grayCircles]:
          role === RolesEnum.superAdmin && !companySelected,
        [classes.blueCircles]: role === RolesEnum.operator && !companySelected,
        [classes.yellowCircles]: companySelected,
        [classes.noCircles]: noCircles,
      })}
    >
      {children}
    </Card>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(AutoCard);
